<template>
    <ion-col size="auto" class="center py-0">
        <div class="max-size center" style="max-width: v-bind(cardHeight); max-height: v-bind(cardHeight);">
            <image-supplier :supplier-id="internalSupplier.id" class="contain-supplier-image"/>
        </div>
    </ion-col>

    <ion-col class="py-0 center-x flex-d-c">
        <ion-row v-if="internalSupplier.city">
            <ion-col class="coral-coral-color">
                {{ internalSupplier.city }}
            </ion-col>
        </ion-row>

        <ion-row>
            <ion-col class="purple-purple-color fw-b">
                {{ internalSupplier.name }}
            </ion-col>
        </ion-row>
    </ion-col>
</template>

<script setup lang="ts">
import { IonCol, IonRow } from "@ionic/vue";
import { Supplier } from "@/types/supplier";
import ImageSupplier from "@/components/image/ImageSupplier.vue";
import { computed } from "vue";
import { useSupplierStore } from "@/stores/suppliers";

const props = defineProps<{ supplier?: Supplier; supplierId?: string }>()
const cardHeight = '50px'

const supplierStore = useSupplierStore()

const internalSupplier = computed<Supplier>(() => {
    if (props.supplier) return props.supplier

    if (!props.supplierId) return {} as Supplier

    return supplierStore.supplierById(props.supplierId) ?? {} as Supplier
})
</script>

<style>
.contain-supplier-image {
    width: v-bind(cardHeight) !important;
    height: v-bind(cardHeight) !important;
    min-width: v-bind(cardHeight) !important;
}

.contain-supplier-image > * {
    object-fit: contain;
}
</style>
